var map = {
	"./192.svg": "3695",
	"./193.svg": "6365",
	"./404/1.svg": "4fbe",
	"./404/2.svg": "e10d",
	"./404/sparks/bottom-1.svg": "8b84",
	"./404/sparks/bottom-2.svg": "3a15",
	"./404/sparks/bottom-3.svg": "9fc0",
	"./404/sparks/bottom-4.svg": "cc34",
	"./404/sparks/top-1.svg": "3e21",
	"./404/sparks/top-2.svg": "d73f",
	"./404/sparks/top-3.svg": "f391",
	"./404/sparks/top-4.svg": "c842",
	"./about-us.svg": "8d09",
	"./admin-career/add-new.svg": "038b",
	"./admin-career/close.svg": "2e71",
	"./admin-career/delete.svg": "1f5d",
	"./admin-career/edit.svg": "0d5b",
	"./admin-career/open.svg": "15e9",
	"./admin/admin img.svg": "7d9c",
	"./admin/announcement-grey.svg": "79e9",
	"./admin/announcement-white.svg": "322a",
	"./admin/careers-grey.svg": "007c",
	"./admin/careers-white.svg": "db6e",
	"./admin/dropdown-1.png": "8227",
	"./admin/dropdown-2.png": "b655",
	"./admin/logo.svg": "d8f7",
	"./admin/logout.png": "0945",
	"./admin/side-menu.svg": "fcb5",
	"./andriod-white.svg": "adbd",
	"./apple-white.svg": "1b93",
	"./archive-news-and-announcements/author.svg": "2825",
	"./archive-news-and-announcements/bg-img-news-and-announcements-mobile.png": "0fff",
	"./archive-news-and-announcements/bg-img-news-and-announcements-tablet.png": "0628",
	"./archive-news-and-announcements/bg-img-news-and-announcements.svg": "e3f5",
	"./archive-news-and-announcements/bg-img-news-and-announcements3.png": "d043",
	"./archive-news-and-announcements/bg-news-and-announcements.svg": "11b7",
	"./archive-news-and-announcements/bg-post-1.png": "b5fc",
	"./archive-news-and-announcements/bg-post-2.jpg": "83af",
	"./archive-news-and-announcements/bg-post-3.png": "0514",
	"./archive-news-and-announcements/bg-post-4.jpg": "fbab",
	"./archive-news-and-announcements/date-and-time.svg": "7b34",
	"./archive-news-and-announcements/overlay-bg-archive-news-and-announcements-mobile.png": "babb",
	"./archive-news-and-announcements/overlay-bg-archive-news-and-announcements-tablet.png": "fcc7",
	"./back-button.svg": "af9b",
	"./baseline-cast_for_education-48px.svg": "60b3",
	"./bg-about-us-mobile.png": "4069",
	"./bg-about-us-our-partners.png": "b5fe",
	"./bg-about-us.png": "e7a8",
	"./bg-careers-tablet-portrait.png": "c08b",
	"./bg-careers.png": "c47a",
	"./bg-img-careers-page-header.png": "0f51",
	"./bg-section-about-company.png": "4723",
	"./bg-section-details-img.png": "046a",
	"./bg-section-details-mobile.png": "7315",
	"./bg-section-details.png": "8fae",
	"./bg-section-features.png": "9793",
	"./bg-section-introduction-mobile.png": "59d1",
	"./bg-section-introduction.png": "d3d5",
	"./bg-szg-download.png": "e867",
	"./bg_product.png": "e0a8",
	"./bident.png": "e4f4",
	"./bident.svg": "8e95",
	"./card-about-us-section-our-core-values-tablet.png": "e317",
	"./card-about-us-section-our-core-values.png": "0962",
	"./careers/bg-careers-mobile.png": "1dad",
	"./careers/bg-careers-section-perks-and-benefits.png": "cf1e",
	"./careers/bg-careers-tablet.png": "8cba",
	"./careers/bg-form-opening-positions-mobile.png": "11b71",
	"./careers/bg-form-opening-positions-mobile.svg": "709a",
	"./careers/bg-form-opening-positions-tablet.png": "3753",
	"./careers/bg-form-opening-positions.png": "ccb7",
	"./careers/career-no-open-position.svg": "f394",
	"./careers/overlay-bg-careers-mobile.png": "2240",
	"./careers/overlay-bg-careers-mobile.svg": "62fe",
	"./careers/overlay-bg-careers-tablet.png": "0271",
	"./circle.png": "d215",
	"./circles-section-features.png": "7641",
	"./close-button.svg": "340b",
	"./close.svg": "1d1b",
	"./consumer-first.svg": "d40e",
	"./consumer-first/1.svg": "c330",
	"./consumer-first/2.svg": "be65",
	"./consumer-first/3.svg": "835b",
	"./contact us copy.svg": "bfb2",
	"./contact-us-close-button-circle.png": "219a",
	"./contact-us-close-button.png": "a6be",
	"./contact-us-title-semicircle.png": "4230",
	"./contact-us.svg": "e882",
	"./contactus-success.png": "0637",
	"./currency-exchange.svg": "52ba",
	"./dl-mockup.png": "1b12",
	"./email.svg": "d773",
	"./fb-contact.svg": "eada",
	"./fb-footer.svg": "4e08",
	"./globe-section-introduction.svg": "c9cd",
	"./globe.svg": "9399",
	"./home-phone.svg": "2b68",
	"./home-section-features/blockchain-technology.svg": "6a90",
	"./home-section-features/financial-security.svg": "43ce",
	"./home-section-features/global-currency-conversion.svg": "8fb1",
	"./home-section-features/multiple-payment-channels.svg": "987b",
	"./home-section-features/user-information-security.svg": "545b",
	"./home-section-features/various-payment-scenarios.svg": "1eba",
	"./humans/human-1.svg": "2bfe",
	"./humans/human-2.svg": "3afd",
	"./humans/human-3.svg": "5410",
	"./humans/human-4.svg": "e12f",
	"./icon-blockchain-tech.svg": "5abb",
	"./icon-financial-security.svg": "a824",
	"./icon-privacy-security.svg": "cd98",
	"./icons-about-us-our-team/customer-service-team.svg": "d96f",
	"./icons-about-us-our-team/product-team.svg": "095d",
	"./icons-about-us-our-team/risk-control-team.svg": "7fba",
	"./icons-about-us-our-team/technical-team.svg": "5f84",
	"./icons-careers-section-perks-and-benefits/1.svg": "c8ff",
	"./icons-careers-section-perks-and-benefits/2.svg": "229a",
	"./icons-careers-section-perks-and-benefits/3.svg": "d56b",
	"./icons-careers-section-perks-and-benefits/4.svg": "9747",
	"./language.svg": "ace5",
	"./latest-news-with-heading.svg": "9a9e",
	"./latest-trading.png": "8587",
	"./linkedin-contact.svg": "37da",
	"./linkedin-footer.svg": "75ad",
	"./location.svg": "e496",
	"./login/admin-logo.png": "a19d",
	"./login/admin-logo.svg": "16f3",
	"./login/bg-1.png": "f643",
	"./login/bg-2.png": "dd18",
	"./login/email.svg": "d20d",
	"./login/img-1.png": "e562",
	"./login/img-1.svg": "9cfd",
	"./login/password.svg": "e0bc",
	"./login/visibility-off.svg": "fc32",
	"./login/visibility-on.svg": "3f99",
	"./logo-grey.png": "34cf",
	"./logo.png": "4ffd",
	"./main-nav/icon-about-us-blue.svg": "d7aa",
	"./main-nav/icon-about-us-white.svg": "f04d",
	"./main-nav/icon-arrow-blue.svg": "f1e4",
	"./main-nav/icon-arrow-white.svg": "e822",
	"./main-nav/icon-careers-blue.svg": "fe08",
	"./main-nav/icon-careers-white.svg": "ba3e",
	"./main-nav/icon-close-button-circle.svg": "0fe4",
	"./main-nav/icon-close-button-cross.svg": "40c0",
	"./main-nav/icon-close-button.svg": "9404",
	"./main-nav/icon-dropdown-arrow-white.svg": "55fc",
	"./main-nav/icon-home-blue.svg": "5e3a",
	"./main-nav/icon-home-white.svg": "f85f",
	"./main-nav/icon-news-blue.svg": "6c7e",
	"./main-nav/icon-news-white.svg": "cca8",
	"./main-nav/icon-products-blue.svg": "cb5c",
	"./main-nav/icon-products-white.svg": "6aa6",
	"./main-nav/tablet-menu-curve.png": "4892",
	"./menu copy.svg": "b816",
	"./minus.svg": "785a",
	"./nav-menu.svg": "114c",
	"./our-partners/our-partners-1.jpg": "e5f5",
	"./our-partners/our-partners-2.jpg": "85fe",
	"./our-partners/our-partners-3.jpg": "e81f",
	"./our-partners/our-partners-4.jpg": "2947",
	"./overlay-bg-about-us-mobile.png": "bbf5",
	"./pagination-1.svg": "63cd",
	"./pagination-2.svg": "045f",
	"./pagination-3.svg": "fcfe",
	"./pagination-4.svg": "396a",
	"./phone-container-1-overlay-tablet.png": "c858",
	"./phone-outline-section-introduction.png": "74bd",
	"./phone-section-introduction.png": "a153",
	"./phones.png": "f1a6",
	"./plus.svg": "2beb",
	"./premium-currency-section-introduction.svg": "58ac",
	"./premium-currency.svg": "3e3d",
	"./product page mockup.png": "af30",
	"./product-box-mobile.png": "a96f",
	"./product-box-tablet.png": "323b",
	"./product-container-1-bg-mobile.png": "8023",
	"./product-container-1-bg.png": "be55",
	"./product-container-1-overlay-mobile.png": "48c7",
	"./product-container-1-overlay-tablet.png": "deb6",
	"./product.svg": "1d0b",
	"./product_box.png": "371c",
	"./qr-code.svg": "526f",
	"./read-more.svg": "6556",
	"./rect.svg": "b952",
	"./robust-trading.svg": "a746",
	"./rotating-circle-section-introduction.png": "a770",
	"./round-lock-24px.svg": "e159",
	"./round-record_voice_over-24px.svg": "aac8",
	"./screen-1.png": "213a",
	"./screen-2.png": "b346",
	"./screen-3.png": "5a9a",
	"./secret/about.png": "5a95",
	"./secret/free-access.png": "decf",
	"./secret/integrated-wallet.png": "1baf",
	"./secret/user-friendly.png": "73a3",
	"./security-first.svg": "249c",
	"./security-section-introduction.svg": "ed59",
	"./security.svg": "9d9b",
	"./security/1.svg": "5305",
	"./security/2.svg": "812c",
	"./single-news-and-announcements/author-image.svg": "3cc9",
	"./single-news-and-announcements/bg-img-news-and-announcements.png": "76f0",
	"./single-news-and-announcements/bg-img-news-and-announcements2.png": "523c",
	"./single-news-and-announcements/bg-img-news-and-announcements3.png": "a93d",
	"./single-news-and-announcements/share-fb.svg": "6410",
	"./single-news-and-announcements/share-google.svg": "242e",
	"./single-news-and-announcements/share-linkedin.svg": "2194",
	"./single-news-and-announcements/share-twitter.svg": "3b54",
	"./szg-phone.png": "5028",
	"./team-about-us-section-our-team.png": "ca05",
	"./telephone-fax.svg": "581c",
	"./time-and-date-white.svg": "d64e",
	"./trading-background-img.svg": "7dad",
	"./trading/1.svg": "d2b2",
	"./trading/2.svg": "87c7",
	"./trading/3.svg": "4574",
	"./trading/4.svg": "e0b8",
	"./transparent-disclosure-section-introduction.svg": "13e5",
	"./transparent-disclosure.svg": "d65b",
	"./whole-team.png": "c533"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";